@if (mode(); as currentMode) {
  <div
    class="auth-redirect-overlay"
    role="status"
    aria-live="polite"
    [attr.aria-label]="copy()?.title"
  >
    <div class="auth-redirect-backdrop"></div>

    <div class="auth-redirect-panel">
      @if (currentMode === 'logout') {
        <div class="auth-redirect-icon" aria-hidden="true">
          <span class="auth-redirect-core">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      } @else {
        <div class="auth-redirect-handoff" aria-hidden="true">
          <div class="auth-redirect-app">
            <span class="auth-redirect-core">
              <ng-container
                [ngTemplateOutlet]="appGlyph"
                [ngTemplateOutletContext]="{ $implicit: sourceApp() }"
              />
            </span>
            @if (sourceLabel()) {
              <span class="auth-redirect-app-label">{{ sourceLabel() }}</span>
            }
          </div>

          <div class="auth-redirect-flow">
            <span class="auth-redirect-flow-line">
              <span class="auth-redirect-flow-beam"></span>
            </span>
            <div class="auth-redirect-flow-chevrons">
              <svg class="auth-redirect-flow-chevron" viewBox="0 0 12 20" aria-hidden="true">
                <path
                  d="M2.5 3.5 9 10l-6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg class="auth-redirect-flow-chevron" viewBox="0 0 12 20" aria-hidden="true">
                <path
                  d="M2.5 3.5 9 10l-6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg class="auth-redirect-flow-chevron" viewBox="0 0 12 20" aria-hidden="true">
                <path
                  d="M2.5 3.5 9 10l-6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg class="auth-redirect-flow-chevron" viewBox="0 0 12 20" aria-hidden="true">
                <path
                  d="M2.5 3.5 9 10l-6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <div class="auth-redirect-app is-target">
            <span class="auth-redirect-core">
              <ng-container
                [ngTemplateOutlet]="appGlyph"
                [ngTemplateOutletContext]="{ $implicit: destApp() }"
              />
            </span>
            @if (destLabel()) {
              <span class="auth-redirect-app-label">{{ destLabel() }}</span>
            }
          </div>
        </div>
      }

      <h2 class="auth-redirect-title">{{ copy()?.title }}</h2>
      <p class="auth-redirect-subtitle">{{ copy()?.subtitle }}</p>
    </div>
  </div>
}

<ng-template #appGlyph let-app>
  @switch (app) {
    @case ('account') {
      <svg lucideUser [size]="20" [strokeWidth]="2"></svg>
    }
    @case ('lab') {
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <path
          d="M9.19807 4.45825C8.55418 4.22291 7.94427 4 7 4C5 4 4 6 4 8.5C4 10.0985 4.40885 11.0838 4.83441 12.1093C5.0744 12.6877 5.31971 13.2788 5.5 14C5.649 14.596 5.7092 15.4584 5.77321 16.3755C5.92401 18.536 6.096 21 7.5 21C8.39898 21 8.79286 19.5857 9.22652 18.0286C9.75765 16.1214 10.3485 14 12 14C13.6515 14 14.2423 16.1214 14.7735 18.0286C15.2071 19.5857 15.601 21 16.5 21C17.904 21 18.076 18.536 18.2268 16.3755C18.2908 15.4584 18.351 14.596 18.5 14C18.6803 13.2788 18.9256 12.6877 19.1656 12.1093C19.5912 11.0838 20 10.0985 20 8.5C20 6 19 4 17 4C16.0557 4 15.4458 4.22291 14.8019 4.45825C14.082 4.72136 13.3197 5 12 5C10.6803 5 9.91796 4.72136 9.19807 4.45825Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    @case ('cad') {
      <svg lucideBox [size]="20" [strokeWidth]="2"></svg>
    }
    @case ('clinic') {
      <svg lucideStethoscope [size]="20" [strokeWidth]="2"></svg>
    }
    @case ('portal') {
      <svg lucideLayoutDashboard [size]="20" [strokeWidth]="2"></svg>
    }
    @default {
      <svg viewBox="0 0 16 16" width="18" height="18" aria-hidden="true">
        <path d="M2 7.2h12v1.7H2z" fill="currentColor" />
        <circle cx="4.2" cy="11.2" r="1.15" fill="currentColor" />
        <circle cx="11.8" cy="11.2" r="1.15" fill="currentColor" />
      </svg>
    }
  }
</ng-template>
